export default __webpack_public_path__ + "static/media/schedule_icon.41853813.svg";